import React from "react";

import * as S from "./styles";

export const Slide11: React.FC = () => {
  const animeZoom = {
    scaling: {
      scale: [1, 1.1, 1],
      transition: { ease: "easeInOut", duration: 40, repeat: Infinity },
    },
  };

  return (
    <S.Container>
      <S.Background animate="scaling" variants={animeZoom} />
      <S.Content>
        <S.Credit>
          Túnica, Haight, R$ 798. Corrente, Skull, R$ 420. Colar, Brennheisen,
          R$ 790.
        </S.Credit>
      </S.Content>
    </S.Container>
  );
};
